import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class FonasaValidationService extends BaseService() {
    static get entity() {
        return "fonasa_validations";
    }
    static get responseName() {
        return "fonasa_validations";
    }
    static getByPatientId(patient_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_patient_id/${patient_id}`,
            });
        });
    }
    static dispatchValidateFonasa(patient_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `dispatch_validate_fonasa/${patient_id}`,
            });
        });
    }
}
